<template>
  <div>
    <div class="topbar-container">
        <el-tabs style="margin-top:0px 20px;" type="card" @tab-click="handleSelect" v-model="activeName" >
            <el-tab-pane label="患者登记" name="first"></el-tab-pane>
            <el-tab-pane label="补单登记" name="second"></el-tab-pane>
            <el-tab-pane label="登记管理" name="third"></el-tab-pane>
        </el-tabs>
    </div>
    <registrationAdmin :is="currentView"  v-on:eee="handleSelect"></registrationAdmin>
  </div>
</template>
<script>
import registration from './registration'
import supplement from './Supplement'
import registrationAdmin from './registrationAdmin'
export default {
  name: 'Registration',
  data() {
    return {
      activeName: 'first',
      currentView: 'registration'
    }
  },
  components: {
    registration,
    supplement,
    registrationAdmin
  },
  created() {
    if (this.$route.query.page === 'registrationAdmin') {
      this.currentView = 'registrationAdmin'
      this.activeName = 'third'
    }
  },
  methods: {
    handleSelect(tab, event) {
      switch (tab.index) {
        case '0':
          this.currentView = 'registration'
          this.$router.push({ name: 'Registration' })
          break
        case '1':
          this.currentView = 'supplement'
          this.$router.push({ name: 'Registration', query: { page: 'supplement' }})
          break
        case '2':
          this.currentView = 'registrationAdmin'
          this.activeName = 'third'
          this.$router.push({ name: 'Registration', query: { page: 'registrationAdmin' }})
          break
      }
    }
  },
  getEdit(value) {
    this.currentView = value
  }
}
</script>
